import * as angular from 'angular';

"use strict";

angular.module('BreadcrumbModule', [])

export default 'BreadcrumbModule';
